export const LEAD_DROP_FORM_2_CONSTANTS = {
  DEFAULT_ROW: {
    // Header / Title section (title = existing column)
    title: "",
    form_title_color: "#000000",
    end_date: "",
    end_time: "",
    gradient_start: "#BE2330",
    gradient_end: "#8B0000",
    date_number_color: "#000000",
    date_text_color: "#666666",
    date_background_color: "#F5F5F5",
    close_icon: "",
    close_icon_alt: "Close",
    title_2: "",
    title_2_color: "#000000",
    sub_text: "", // existing column (description)
    description_color: "#666666",
    // Step 1 button (existing columns)
    button_text: "Sign Up",
    button_text_color: "#FFFFFF",
    button_background_color: "#BE2330",
    // Step 2 button
    button_step_2_text: "Continue",
    button_step_2_text_color: "#FFFFFF",
    button_step_2_background_color: "#BE2330",
    // Checkbox
    checkbox_color: "#BE2330",
    checkbox_description: "",
    checkbox_description_color: "#666666",
    // OTP section
    otp_header_text: "",
    otp_header_text_color: "#000000",
    otp_header_description: "",
    otp_header_description_color: "#666666",
    edit_number_text: "Edit",
    edit_number_text_color: "#BE2330",
    otp_title: "",
    otp_title_color: "#000000",
    resend_otp_text: "Resend OTP",
    resend_otp_text_color: "#BE2330",
    otp_description_text: "",
    otp_description_text_color: "#666666",
    // Success section (success_* = existing columns)
    success_title: "",
    success_title_color: "#000000",
    success_subtitle: "",
    success_subtitle_color: "#666666",
    success_description: "",
    success_description_text_color: "#666666",
    success_description_color: "#666666",
    success_button_text: "Continue",
    success_button_link: "",
    success_button_text_color: "#FFFFFF",
    success_button_background_color: "#BE2330",
    success_button_icon: "",
    success_icon: "",
    success_icon_alt: "Success",
    success_background_image: "",
    success_background_image_alt: "Success section background",
  },

  LEAD_DROP_FORM_FIELDS_CONFIG: [
    // Title and header
    {
      fieldName: "title",
      label: "Form Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Form Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "form_title_color",
      label: "Form Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Form Title Color (e.g., #000000)",
      required: false,
      isJsonField: true,
      defaultValue: "#000000",
    },
    {
      fieldName: "end_date",
      label: "End Date",
      value: "",
      valueType: "string",
      filedType: "DATE",
      placeholder: "Select end date",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "end_time",
      label: "End Time",
      value: "",
      valueType: "string",
      filedType: "TIME",
      placeholder: "Select end time",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "gradient_start",
      label: "Gradient Start Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient Start Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "gradient_end",
      label: "Gradient End Color",
      value: "#8B0000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Gradient End Color (e.g., #8B0000)",
      required: false,
      isJsonField: true,
      defaultValue: "#8B0000",
    },
    {
      fieldName: "date_number_color",
      label: "Date Number Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Date Number Color (e.g., #000000)",
      required: false,
      isJsonField: true,
      defaultValue: "#000000",
    },
    {
      fieldName: "date_text_color",
      label: "Date Text Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Date Text Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    {
      fieldName: "date_background_color",
      label: "Date Background Color",
      value: "#F5F5F5",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Date Background Color (e.g., #F5F5F5)",
      required: false,
      isJsonField: true,
      defaultValue: "#F5F5F5",
    },
    {
      fieldName: "close_icon",
      label: "Close Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Close Icon",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "close_icon_alt",
      label: "Close Icon Alt Text",
      value: "Close",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for close icon",
      required: false,
      isJsonField: true,
      defaultValue: "Close",
    },
    {
      fieldName: "title_2",
      label: "Title 2",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title 2",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "title_2_color",
      label: "Title 2 Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Title 2 Color (e.g., #000000)",
      required: false,
      isJsonField: true,
      defaultValue: "#000000",
    },
    {
      fieldName: "sub_text",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
      required: false,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "description_color",
      label: "Description Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Description Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    // Button step 1 (existing columns)
    {
      fieldName: "button_text",
      label: "Button Step 1 Text (Form screen)",
      value: "Sign Up",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Button Step 1 Text",
      required: false,
      defaultValue: "Sign Up",
    },
    {
      fieldName: "button_text_color",
      label: "Button Step 1 Text Color (Form screen)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Step 1 Text Color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_background_color",
      label: "Button Background Color (Form screen)",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Background Color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    // Button step 2
    {
      fieldName: "button_step_2_text",
      label: "Button Step 2 Text (OTP screen)",
      value: "Continue",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Button Step 2 Text",
      required: false,
      isJsonField: true,
      defaultValue: "Continue",
    },
    {
      fieldName: "button_step_2_text_color",
      label: "Button Step 2 Text Color (OTP screen)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Step 2 Text Color (e.g., #FFFFFF)",
      required: false,
      isJsonField: true,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "button_step_2_background_color",
      label: "Button Step 2 Background Color (OTP screen)",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Button Step 2 Background Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    // Checkbox
    {
      fieldName: "checkbox_color",
      label: "Checkbox Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Checkbox Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "checkbox_description",
      label: "Checkbox Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Checkbox Description",
      required: false,
      defaultValue: "",
      rows: 2,
    },
    {
      fieldName: "checkbox_description_color",
      label: "Checkbox Description Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Checkbox Description Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    // OTP section
    {
      fieldName: "otp_header_text",
      label: "OTP Header Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter OTP Header Text",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "otp_header_text_color",
      label: "OTP Header Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter OTP Header Text Color (e.g., #000000)",
      required: false,
      isJsonField: true,
      defaultValue: "#000000",
    },
    {
      fieldName: "otp_header_description",
      label: "OTP Header Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter OTP Header Description",
      required: false,
      isJsonField: true,
      defaultValue: "",
      rows: 2,
    },
    {
      fieldName: "otp_header_description_color",
      label: "OTP Header Description Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter OTP Header Description Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    {
      fieldName: "edit_number_text",
      label: "Edit Number Text",
      value: "Edit",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Edit Number Text",
      required: false,
      isJsonField: true,
      defaultValue: "Edit",
    },
    {
      fieldName: "edit_number_text_color",
      label: "Edit Number Text Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Edit Number Text Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "otp_title",
      label: "OTP Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter OTP Title",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "otp_title_color",
      label: "OTP Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter OTP Title Color (e.g., #000000)",
      required: false,
      isJsonField: true,
      defaultValue: "#000000",
    },
    {
      fieldName: "resend_otp_text",
      label: "Resend OTP Text",
      value: "Resend OTP",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Resend OTP Text",
      required: false,
      isJsonField: true,
      defaultValue: "Resend OTP",
    },
    {
      fieldName: "resend_otp_text_color",
      label: "Resend OTP Text Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Resend OTP Text Color (e.g., #BE2330)",
      required: false,
      isJsonField: true,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "otp_description_text",
      label: "OTP Description Text",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter OTP Description Text",
      required: false,
      isJsonField: true,
      defaultValue: "",
      rows: 2,
    },
    {
      fieldName: "otp_description_text_color",
      label: "OTP Description Text Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter OTP Description Text Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    // Success section (success_* = existing columns)
    {
      fieldName: "success_title",
      label: "Success Title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Success Title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "success_title_color",
      label: "Success Title Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Success Title Color (e.g., #000000)",
      required: false,
      isJsonField: true,
      defaultValue: "#000000",
    },
    {
      fieldName: "success_subtitle",
      label: "Success Subtitle",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Success Subtitle",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "success_subtitle_color",
      label: "Success Subtitle Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Success Subtitle Color (e.g., #666666)",
      required: false,
      isJsonField: true,
      defaultValue: "#666666",
    },
    {
      fieldName: "success_description",
      label: "Success Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Success Description",
      required: false,
      defaultValue: "",
      rows: 3,
    },
    {
      fieldName: "success_description_text_color",
      label: "Success Description Text Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Success Description Text Color (e.g., #666666)",
      required: false,
      defaultValue: "#666666",
    },
    {
      fieldName: "success_description_color",
      label: "Success Description Color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Success Description Color (e.g., #666666)",
      required: false,
      defaultValue: "#666666",
    },
    {
      fieldName: "success_button_text",
      label: "Success Button Text",
      value: "Continue",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Success Button Text",
      required: false,
      defaultValue: "Continue",
    },
    {
      fieldName: "success_button_text_color",
      label: "Success Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Success Button Text Color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "success_button_background_color",
      label: "Success Button Background Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter Success Button Background Color (e.g., #BE2330)",
      required: false,
      defaultValue: "#BE2330",
    },
    {
      fieldName: "success_button_icon",
      label: "Success Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Success Button Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "success_icon",
      label: "Success Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Success Icon",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "success_icon_alt",
      label: "Success Icon Alt Text",
      value: "Success",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for Success icon",
      required: false,
      defaultValue: "Success",
    },
    {
      fieldName: "success_background_image",
      label: "Success Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Success Section Background Image",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
    {
      fieldName: "success_background_image_alt",
      label: "Success Background Image Alt Text",
      value: "Success section background",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for Success section background",
      required: false,
      isJsonField: true,
      defaultValue: "Success section background",
    },
    {
      fieldName: "success_button_link",
      label:
        "Success button link (optional) — opens in a new tab when set; leave empty to keep the current behaviour (back to website)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "https://example.com/... (leave empty to keep current behaviour)",
      required: false,
      isJsonField: true,
      defaultValue: "",
    },
  ],

  METADATA_FIELDS: [],
};
